export const WORKSPACE_MODULE_COLORS = [
  '#1E88E5',
  '#E53935',
  '#FB8C00',
  '#FDD835',
  '#43A047',
  '#00897B',
  '#29B6F6',
  '#8E24AA',
  '#FFFFFF',
  '#212121',
  '#F48FB1',
  '#CE93D8',
  '#B39DDB',
  '#90CAF9',
  '#80CBC4',
  '#A5D6A7',
  '#FFF59D',
  '#FFCC80',
  '#BCAAA4',
  '#9E9E9E',
  '#78909C',
  '#5D4037',
  '#6D4C41',
  '#37474F',
  '#C62828',
  '#AD1457',
  '#6A1B9A',
  '#4527A0',
  '#283593',
  '#1565C0',
  '#0277BD',
  '#00695C',
  '#2E7D32',
  '#558B2F',
  '#9E9D24',
  '#F9A825',
  '#FF6F00',
  '#D84315',
] as const
